module.exports = __webpack_public_path__ + "img/arepa_carne_mechada.7927e7ad.jpeg";